import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useTranslation, withTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch } from "react-redux";

//Validation
import { Formik } from "formik";
import * as Yup from "yup";

import { getProfile } from "../../../redux/actions/actions";
import SecurityLevelPassword from "../SecurityLevelPassword";

import "react-toastify/dist/ReactToastify.css";
import { axiosGet, axiosPut } from "../../../helper/fetch";

const validate = (getValidationSchema) => {
  return (values) => {
    const validationSchema = getValidationSchema(values);
    try {
      validationSchema.validateSync(values, {
        abortEarly: false,
      });
      return {};
    } catch (err) {
      return this.getErrorsFromValidationError(err);
    }
  };
};

const ChangePasswordModal = ({shownVarName,toggleClose, userId, username, hiddenChangePassword, shown}) => {
  /** STATE */
  const [user, setUser] = useState({
    password: "",
    repeatPassword: "",
    requireChangePassword: 0,
  });
  const [minPasswordLength, setMinPasswordLength] = useState(0);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [inputChecked, setInputChecked] = useState(false);

  /** HOOKS */
  const {t} = useTranslation();
  const dispatch = useDispatch();
  let isSuscribed;

  useEffect(() =>{
    isSuscribed = true;
    (async() =>{
      await getMinPasswordLenght();
    })()
    return () => isSuscribed = false;
  },[]);

  const validationSchema = () => {
    return Yup.object().shape({
      password: Yup.string()
        .min(
          this.state.minPasswordLength,
          t("ChangePassword.validationPasswordLenght")
        )
        .required(t("ChangePassword.validationPassword")),
      repeatPassword: Yup.string().required(
        t("ChangePassword.validationRepeatPassword")
      ),
    });
  };

   /*** Maneja el estado del radio button "Requiere cambio de pass.." */
  const handleInputChange = (event) => {
    const target = event.target;
    const value =
      target.type === "radio" ? parseInt(target.value, 2) : target.value;
    if ( target.type === "radio" ){
      setInputChecked(!inputChecked)
    }  
    const name = target.name;  
    user[name] = value;
    setUser(user);
  };


  const errorFn = (values) => {
    let error_ = false;
    let errorMessage_;
    if (values.password !== values.repeatPassword) {
      error_ = true;
      errorMessage_ = t("ChangePassword.validationPasswordEquals");
    }
    setError(error_);
    setErrorMessage(errorMessage_);
    return error_;
  };

  const save = async (values) => {
    user.password = values.password;
    user.repeatPassword = values.repeatPassword;
    if (!errorFn(values)) {
      const data = {
        userId: userId, // CHECK PROPS
        username: username, // CHECK PROPS
        password: values.password,
        reqChangePassword: user.requireChangePassword,
      };
      console.log(">>> data: ", data);
      try {
        await axiosPut(`api/user/change-password`, data);
        /*await axios({
          url: `api/user/change-password`,
          method: "PUT",
          data: JSON.stringify(data),
        });*/
        if (hiddenChangePassword) {
          dispatch(getProfile());
        }
        toast.success(t("ChangePassword.confirm"), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        toggleClose({ target: { name: shownVarName } });
      } catch (err) {
        console.error(">>> Error al modificar la contraseña: ", err);
        toast.error(t("ChangePassword.error"), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    }
  };

  const reset = (values) => {
    const user_ = {
      password: "",
      repeatPassword: "",
      requireChangePassword: 0,
    };
    values.password = "";
    values.repeatPassword = "";
    getMinPasswordLenght();
    setUser(user_);
    setError(false);
    setErrorMessage("");
  };

  const getMinPasswordLenght = async () => {
    const resMinPass = await axiosGet(`api/user/min-password-length`, 'GET');
    if (isSuscribed){
      setMinPasswordLength(resMinPass.data);
    }
  };

  const containerStyle = { zIndex: 1500 };
    
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={user}
        validate={validate(validationSchema)}
        onSubmit={save}
        render={({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <Form>
            <Modal
              onOpened={() => reset(values)}
              isOpen={shown}
              className="c-modal-cover"
              toggle={toggleClose}
              name={shownVarName}
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <ModalHeader>{`${username} - ${t("DefaultLayout.changePassword")}`}</ModalHeader>
              <ModalBody>
                <Col md="12" style={{ marginTop: 15 }}>
                  <Label style={{ paddingTop: 5 }}>
                    {t("ChangePassword.newPassword")}
                  </Label>
                </Col>
                <Col md="12">
                  <Input
                    type="password"
                    name="password"
                    id="password"
                    invalid={touched.password && !!errors.password}
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                  />
                  <FormFeedback>{errors.password}</FormFeedback>
                  <SecurityLevelPassword
                    lenght={values.password.length}
                    password={values.password}
                    username={username}
                  />
                </Col>
                <Col md="12" style={{ marginTop: 15 }}>
                  <Label style={{ paddingTop: 5 }}>
                    {t("ChangePassword.newRepeatPassword")}
                  </Label>
                </Col>
                <Col md="12">
                  <Input
                    type="password"
                    name="repeatPassword"
                    id="repeatPassword"
                    invalid={touched.repeatPassword && !!errors.repeatPassword}
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.repeatPassword}
                  />
                  <FormFeedback>{errors.repeatPassword}</FormFeedback>
                  {
                    values.repeatPassword !== values.password || values.repeatPassword === ""
                    ? (
                      <Label style={{ color: "#d43b3b", fontSize: "90%", marginTop: 0 }}>
                        {t("ChangePassword.passwordNotEquals")}
                      </Label>
                      )
                    : (
                      <Label style={{ color: "#4b9c7d", fontSize: "90%", marginTop: 0 }}>
                        {t("ChangePassword.passwordEquals")}
                      </Label>
                    )
                  }
                  {/* <Label
                    style={{ color: "#d43b3b", fontSize: "90%", marginTop: 0 }}
                    hidden ={
                      values.repeatPassword === "" ||
                      values.repeatPassword !== values.password
                    }
                  >
                    {`rep: ${values.repeatPassword} pas: ${values.password}`}
                    {t("ChangePassword.passwordNotEquals")}
                  </Label>
                  <Label
                    style={{ color: "#4b9c7d", fontSize: "90%", marginTop: 0 }}
                    hidden={
                      values.repeatPassword === "" ||
                      values.repeatPassword === values.password
                    }
                  >
                    {values.repeatPassword}
                    {t("ChangePassword.passwordEquals")}
                  </Label> */}
                </Col>
                <Col
                  md="12"
                  style={{ marginTop: 15 }}
                  hidden={hiddenChangePassword}
                >
                  <Label htmlFor="text-input">
                    {t("ChangePassword.requireChangePassword")}
                  </Label>
                </Col>
                <Col md="12" hidden={hiddenChangePassword}>
                  <FormGroup check inline>
                    <Input
                      className="form-check-input"
                      type="radio"
                      id="ir-pc"
                      name="requireChangePassword"
                      value={1}
                      checked={inputChecked}
                      onChange={handleInputChange}
                    />
      
                    <Label className="form-check-label" check htmlFor="ir-pc">
                      {t("ChangePassword.checkYes")}             
                    </Label>
                  </FormGroup>
                  <FormGroup check inline>
                    <Input
                      className="form-check-input"
                      type="radio"
                      id="ir-npc"
                      name="requireChangePassword"
                      value={0}
                      checked={!inputChecked}
                      onChange={handleInputChange}
                    />
                    <Label className="form-check-label" check htmlFor="ir-npc">
                      {t("ChangePassword.checkNo")}
                    </Label>
                  </FormGroup>
                </Col>
                <Col md="12" style={{ marginTop: 15 }}>
                  <Alert color="danger" hidden={!error}>
                    {errorMessage}
                  </Alert>
                </Col>
              </ModalBody>
              <ModalFooter>
                <Button 
                  color="danger" 
                  onClick={handleSubmit}
                  disabled={values.password !== "" && values.password === values.repeatPassword ? false : true}
                >
                  {t("ChangePassword.passwordChange")}
                </Button>
                <Button 
                  color="primary" 
                  name={shownVarName}
                  onClick={toggleClose}>
                  {t("ChangePassword.close")}
                </Button>
              </ModalFooter>
            </Modal>
          </Form>
        )}
      />
      {/* <div className="animated">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          style={containerStyle}
          closeOnClick
        />
      </div> */}
    </>
  );
}


ChangePasswordModal.propTypes = {
  shown: PropTypes.bool,
  hiddenChangePassword: PropTypes.bool,
  username: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  toggleClose: PropTypes.func,
  shownVarName: PropTypes.string.isRequired,
};

export default withTranslation()(ChangePasswordModal);
